/* DENSA — kaydirinca beliren bolumler + akan seritlerin yaklasinca baslamasi
   (ortak dosya; her bolum dahil eder, bir kez calisir)

   19 Agu 2026 — v6: GEC OLCUM KALIBI. Kurucu: Chrome gizli sekmede ustte cikan ucuncu-taraf cerez seridi
   kapaninca banner/karusel kadrajlari duzeldi -> bazi moduller ilk olcumu tek sefer yapiyordu. Bu dosya
   artik yukleme sonrasi (load + 600ms), yazi tipleri gelince (document.fonts.ready) ve 1800ms'de birer kez
   sentetik `resize` olayi yayar; resize dinleyen tum moduller (duzen-banner, karuseller, hero, formul
   karuseli, cografya gezinme, mini kutu) kendilerini yeniden olcer. Yan etki yok: olaylar idempotent.

   14 Agu 2026 — v5: BURADAKI VIDEO OTOMATIGI GERI ALINDI (kok neden densa-fa-karusel.js icindeydi;
   cozum snippets/scripts.liquid). Bu dosya videoya HIC dokunmuyor. */
(function () {
  if (window.__densaReveal) { window.__densaReveal(); return; }

  function tara() {
    var liste = document.querySelectorAll('.dana-reveal:not(.gorunur)');
    Array.prototype.forEach.call(liste, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * .92 && r.bottom > 0) el.classList.add('gorunur');
    });
  }
  window.__densaReveal = tara;
  window.addEventListener('scroll', tara, { passive: true });
  window.addEventListener('resize', tara);
  window.addEventListener('load', tara);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara);
  else tara();

  /* ── v6: gec olcum — sentetik resize ── */
  if (!window.__densaGecOlcum) {
    window.__densaGecOlcum = true;
    var yay = function () { try { window.dispatchEvent(new Event('resize')); } catch (e) {} };
    window.addEventListener('load', function () { setTimeout(yay, 600); setTimeout(yay, 1800); });
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(yay, 50); }); } catch (e) {}
    if ('ResizeObserver' in window) {
      try {
        var sonW = document.documentElement.clientWidth, sonH = window.innerHeight;
        new ResizeObserver(function () {
          var w = document.documentElement.clientWidth, h = window.innerHeight;
          if (w !== sonW || Math.abs(h - sonH) > 40) { sonW = w; sonH = h; yay(); }
        }).observe(document.documentElement);
      } catch (e) {}
    }
  }

  /* ── akan seritler: sayfa acilir acilmaz akmasin, kullanici yaklasinca baslasin ──
     (satis noktalari bandi; kurucu talebi 14 Agu 2026) */
  if (window.__densaAkis) return;
  window.__densaAkis = true;

  function seritleriBagla() {
    var adaylar = document.querySelectorAll('.dana-noktalar *:not([data-densa-akis])');
    Array.prototype.forEach.call(adaylar, function (e) {
      var s = getComputedStyle(e);
      if (!s.animationName || s.animationName === 'none') return;
      e.setAttribute('data-densa-akis', '1');
      e.style.animationPlayState = 'paused';
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (g, o) {
          g.forEach(function (x) {
            if (x.isIntersecting) { e.style.animationPlayState = 'running'; o.unobserve(e); }
          });
        }, { threshold: 0, rootMargin: '120px 0px' }).observe(e);
      } else {
        e.style.animationPlayState = 'running';
      }
    });
  }

  seritleriBagla();
  window.addEventListener('load', seritleriBagla);
  document.addEventListener('DOMContentLoaded', seritleriBagla);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      clearTimeout(window.__densaAkisZam);
      window.__densaAkisZam = setTimeout(seritleriBagla, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
